import { useLingui } from "@lingui/react/macro";
import { Box, Container, Link as MuiLink } from "@mui/material";
import ReactMarkdown, { type Components } from "react-markdown";
import AppLayout from "@/components/AppLayout";
import BackToBookingButton from "@/components/BackToBookingButton";
import dePolicy from "./content/de.md?raw";
import enPolicy from "./content/en.md?raw";

const markdownComponents: Components = {
  a({ href, children }) {
    const external = href?.startsWith("http");
    return (
      <MuiLink
        href={href}
        target={external ? "_blank" : undefined}
        rel={external ? "noreferrer" : undefined}
      >
        {children}
      </MuiLink>
    );
  },
};

export default function PrivacyPolicy() {
  const { i18n } = useLingui();
  const policy = i18n.locale === "de" ? dePolicy : enPolicy;

  return (
    <AppLayout contentMaxWidth="md">
      <Container maxWidth="md" sx={{ py: { xs: 3, sm: 4 }, px: { xs: 2, sm: 3 } }}>
        <BackToBookingButton />
        <Box
          sx={(theme) => ({
            "& h1": {
              ...theme.typography.h2,
              marginTop: theme.spacing(2),
              marginBottom: theme.spacing(1.5),
            },
            "& > h1 + p": {
              ...theme.typography.h4,
              marginTop: 0,
              marginBottom: theme.spacing(1),
            },
            "& > h1 + p + p": {
              ...theme.typography.body2,
              color: theme.palette.text.secondary,
              marginTop: 0,
              marginBottom: theme.spacing(3),
            },
            "& h2": {
              ...theme.typography.h3,
              marginTop: theme.spacing(3.5),
              marginBottom: theme.spacing(1.5),
            },
            "& h3": {
              ...theme.typography.h4,
              marginTop: theme.spacing(2.5),
              marginBottom: theme.spacing(1.5),
            },
            "& p": {
              ...theme.typography.body1,
              marginTop: 0,
              marginBottom: theme.spacing(1.5),
            },
            "& ul": {
              marginTop: 0,
              marginBottom: theme.spacing(1.5),
              paddingLeft: theme.spacing(3),
            },
            "& li": {
              ...theme.typography.body1,
              marginBottom: theme.spacing(0.75),
            },
          })}
        >
          <ReactMarkdown components={markdownComponents}>{policy}</ReactMarkdown>
        </Box>
      </Container>
    </AppLayout>
  );
}
